import React from 'react'
import styled from 'styled-components'
import { Callout } from 'sutra/components/Callout/Callout'
import { gray } from 'sutra/tokens/colors'
import { spacing } from 'sutra/tokens/spacing'
import { typography } from 'sutra/tokens/typography'

export interface SubmitBlockersProps {
  blockers: string[]
}

/** Warning callout listing what still stands between the user and a
 * submittable form. Renders nothing when `blockers` is empty. */
export const SubmitBlockers: React.FC<SubmitBlockersProps> = ({ blockers }) => {
  if (blockers.length === 0) return null
  return (
    <Callout variant="warning">
      <Lead>Before you can continue:</Lead>
      <List>
        {blockers.map((blocker) => (
          <li key={blocker}>{blocker}</li>
        ))}
      </List>
    </Callout>
  )
}

const Lead = styled.div`
  font-family: ${typography.fontFamily};
  font-weight: ${typography.weights.semibold};
  color: ${gray[900]};
`

const List = styled.ul`
  margin: ${spacing[1]}px 0 0;
  padding-left: ${spacing[5]}px;
  font-family: ${typography.fontFamily};
  color: ${gray[700]};
`
